export default {"src":"/_next/static/media/AcceptableIcon.4fc84c51.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};